<template>
	<div class="full" style="overflow: hidden;">
		<van-row style="bottom: 82px;top: 0;position: absolute;width: 100%;">
			<van-col :span="filterDate.length==0?0:4"
				style="position: relative;height: 100%;background-color: #f7f8fa;">
				<van-sidebar style="height: 100%;width: 100%;overflow: auto;" v-model="activeKey"
					@change="sidebarChange" v-if="filterDate.length!=0">
					<van-sidebar-item title="清空" />
					<van-sidebar-item :badge="item.badge" v-for="(item,index) in filterDate" :key="index"
						style="padding: 20px 10px 20px 10px;" :title="item.title" />
				</van-sidebar>
			</van-col>
			<van-col style="position: relative;height: 100%;" :span="filterDate.length==0?24:20">
				<div style="position: relative;">
					<van-tabs type="card" style="margin-top: 10px;" @change="warehousetypeChange">
						<van-tab title="本仓" :name="1"></van-tab>
						<van-tab title="委托" :name="2"></van-tab>
					</van-tabs>
				</div>
				<div style="position: relative;height: 100%;">
					<van-tabs class="full">
						<van-tab>
							<template #title>
								<van-badge v-if="data['自提'].length" :content="data['自提'].length" />
								<span>自提</span>
							</template>
							<div class="tab_content">
								<div class="card" v-for="(item,index) in data['自提']" :key="index">
									<div class="card_item flex">
										<el-tag v-if="item.urgent" size="mini" type="danger" style="margin-right: 10px;"
											effect="dark">急</el-tag>
										<span style="font-size: 12px;font-weight: bolder;">预计到货
											{{$systemMethods.timestampToDate(item.pregettime,true)}}</span>
									</div>
									<hr />
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">供应商:</span>
										<span>{{item.supplierName}}</span>

									</div>
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">仓库:</span>
										<span>{{item.storageName}}</span>
									</div>
									<!-- 								<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">方式:</span>
										<span>{{$systemMethods.getEmunValue('parceltype',item.parceltype)}}</span>
									</div> -->
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">规格:</span>
										<span>{{item.detail.length}}种</span>
									</div>
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">备注:</span>
										<span>{{item.remark}}</span>
									</div>
									<!-- 								<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">标记:</span>
										<van-switch size="20px" v-model="item.checked" @change="checkChange(item)" />
									</div> -->
									<div class="card_button flex">
										<div class="operatebutton_container flex">
											<van-button size='mini' type="info" @click="detail(item)">详情</van-button>
										</div>
									</div>
								</div>
							</div>
						</van-tab>
						<van-tab>
							<template #title>
								<van-badge v-if="data['物流'].length" :content="data['物流'].length" />
								<span>物流</span>
								
							</template>
							<div class="tab_content">
								<div class="card" v-for="(item,index) in data['物流']" :key="index">
									<div class="card_item flex">
										<span style="font-size: 12px;font-weight: bolder;">预计到货
											{{$systemMethods.timestampToDate(item.pregettime,true)}}</span>

									</div>
									<hr />
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">供应商:</span>
										<span>{{item.supplierName}}</span>
									</div>
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">仓库:</span>
										<span>{{item.storageName}}</span>
									</div>
									<!-- 								<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">方式:</span>
										<span>{{$systemMethods.getEmunValue('parceltype',item.parceltype)}}</span>
									</div> -->
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">规格:</span>
										<span>{{item.detail.length}}种</span>
									</div>
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">备注:</span>
										<span>{{item.remark}}</span>
									</div>
									<!-- 								<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">标记:</span>
										<van-switch size="20px" v-model="item.checked" @change="checkChange(item)" />
									</div> -->
									<div class="card_button flex">
										<div class="operatebutton_container flex">
											<van-button size='mini' type="info" @click="detail(item)">详情</van-button>
										</div>
									</div>
								</div>
							</div>
						</van-tab>
						<van-tab>
							<template #title>
								<van-badge v-if="data['已提'].length" :content="data['已提'].length" />
								<span>已提</span>
								
							</template>
							<div class="tab_content">
								<div class="card" v-for="(item,index) in data['已提']" :key="index">
									<div class="card_item flex">
										<span style="font-size: 12px;font-weight: bolder;">预计到货
											{{$systemMethods.timestampToDate(item.pregettime,true)}}</span>

									</div>
									<hr />
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">供应商:</span>
										<span>{{item.supplierName}}</span>
									</div>
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">仓库:</span>
										<span>{{item.storageName}}</span>
									</div>
									<!-- 								<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">方式:</span>
										<span>{{$systemMethods.getEmunValue('parceltype',item.parceltype)}}</span>
									</div> -->
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">规格:</span>
										<span>{{item.detail.length}}种</span>
									</div>
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">备注:</span>
										<span>{{item.remark}}</span>
									</div>
									<!-- 								<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">标记:</span>
										<van-switch size="20px" v-model="item.checked" @change="checkChange(item)" />
									</div> -->
									<div class="card_button flex">
										<div class="operatebutton_container flex">
											<van-button size='mini' type="info" @click="detail(item)">详情</van-button>
										</div>
									</div>
								</div>
							</div>
						</van-tab>
						<van-tab>
							<template #title>
								<van-badge v-if="data['缺货'].length" :content="data['缺货'].length" />
								<span>缺货</span>
								
							</template>
							<div class="tab_content">
								<div class="card" v-for="(item,index) in data['缺货']" :key="index">
									<div class="card_item flex">
										<span style="font-size: 12px;font-weight: bolder;">预计到货
											{{$systemMethods.timestampToDate(item.pregettime,true)}}</span>

									</div>
									<hr />
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">供应商:</span>
										<span>{{item.supplierName}}</span>
									</div>
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">仓库:</span>
										<span>{{item.storageName}}</span>
									</div>
									<!-- 								<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">方式:</span>
										<span>{{$systemMethods.getEmunValue('parceltype',item.parceltype)}}</span>
									</div> -->
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">规格:</span>
										<span>{{item.detail.length}}种</span>
									</div>
									<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">备注:</span>
										<span>{{item.remark}}</span>
									</div>
									<!-- 								<div class="card_item flex">
										<span style="font-weight: bolder; width: 60px;">标记:</span>
										<van-switch size="20px" v-model="item.checked" @change="checkChange(item)" />
									</div> -->
									<div class="card_button flex">
										<div class="operatebutton_container flex">
											<van-button size='mini' type="info" @click="detail(item)">详情</van-button>
										</div>
									</div>
								</div>
							</div>
						</van-tab>
					</van-tabs>
				</div>
			</van-col>
		</van-row>
		<div class="flex" style="width: 100%;bottom: 0;position: absolute;">
			<van-button type="danger" style="bottom: 0;flex: 1;" @click="search">查询</van-button>
			<van-button type="info" style="bottom: 0;flex: 1;" @click="calendar">预计到货时间</van-button>
			<van-button type="primary" style="bottom: 0;flex: 1;" @click="reflash">重置</van-button>
		</div>

		<van-calendar get-container="body" ref="calendar" title="预计到货时间" :formatter="formatter" v-model="calendarShow"
			type="multiple" @confirm="onConfirm" :min-date="minDate" />

		<van-popup get-container="body" v-model="detailShow" position="left" :style="{ width: '70%',height:'100%' }">
			<div style="box-sizing: border-box;padding: 10px;">
				<div v-for="(item,index) in detial" :key="index">
					<div>
						<div style="font-weight: bolder;">订单：{{item.billCode}}</div>
						<div style="font-weight: bolder;font-size: 12px;" v-if="item.reportTime">
							报货：{{$systemMethods.timestampToDate(item.reportTime,true)}}</div>
						<div style="font-weight: bolder;font-size: 12px;">
							预计：{{$systemMethods.timestampToDate(item.pregettime,true)}}</div>
						<div style="font-size: 12px;color: #F56C6C;font-weight: bolder;">备注：{{item.remark}}</div>
					</div>
					<div v-for="(goodsItem,goodsIndex) in item.detail" :key="goodsIndex">
						<div
							style="font-size: 14px;margin-top: 10px;color: #409EFF;font-weight: bolder;margin-bottom: 10px;">
							{{goodsIndex}}
						</div>
						<div v-for="(skuItem,skuIndex) in goodsItem" :key="skuIndex">
							<div class="flex"
								style="font-weight: bolder;font-size: 12px;justify-content: space-between;margin-top: 10px;">
								<span>({{skuIndex+1}}) {{skuItem.skuName}}</span>
								<span>{{parseInt(skuItem.size)+ ' '+skuItem.unitName}}</span>
							</div>
							<div class="flex" style="align-items: center;margin-top: 10px;">
								<span style="font-weight: bolder; font-size: 12px;margin-right: 10px;">提</span>
								<van-switch :active-value="1" :inactive-value="0" size="12px" v-model="skuItem.marktake"
									@change="marktakeChange(skuItem)" active-color="#67C23A" inactive-color="#dcdee0" />

								<span
									style="font-weight: bolder; font-size: 12px;margin-right: 10px;margin-left: 50px;">缺</span>
								<van-switch :active-value="1" :inactive-value="0" active-color="#ee0a24"
									inactive-color="#dcdee0" size="12px" :value="skuItem.isoutofstock"
									@input="((checked)=>{outofstockChange(checked,skuItem)})" />
							</div>
							<div style="display: block;font-size: 12px;font-weight: bolder;margin-top: 10px;">
								<span style="color: #ee0a24;">{{skuItem.outofstockmark}}</span>
							</div>
							<hr />
						</div>
					</div>
					<!-- <hr /> -->
				</div>
			</div>
		</van-popup>


		<van-popup get-container="body" v-model="searchShow" position="top" :style="{ width: '100%',height:'50%' }">
			<div style="box-sizing: border-box;padding: 10px;">
				<van-form @submit="onsearchSubmit" >
					<van-field v-model="searchform.billcode" label="采购订单" placeholder="关键字" />
					<van-field style="margin-top: 20px;" v-model="searchform.supplier" label="供应商" placeholder="关键字" />	
					<div style="margin-top: 50px;">
						<van-button block type="info" native-type="submit">确认</van-button>
					</div>
				</van-form>
			</div>
		</van-popup>



		<van-dialog v-model="formShow" title="缺货原因" show-cancel-button @confirm="formSubmit" @cancel="formCancel">
			<van-field type="textarea" v-model="form.mark" placeholder="缺货原因(可不填)" />
		</van-dialog>
	</div>
</template>
<style>

</style>
<style scoped>
	.tab_content {
		position: absolute;
		top: 60px;
		bottom: 0px;
		box-sizing: border-box;
		padding: 2px 10px;
		overflow: auto;
		padding-bottom: 100px;
		width: 100%;
	}

	.card_contaienr {
		position: relative;
		width: 100%;
		flex: 1;
		overflow-x: hidden;
		overflow-y: auto;
		box-sizing: border-box;
		padding: 10px;
	}

	.card {
		position: relative;
		width: 100%;
		border-radius: 2px;
		overflow: hidden;
		box-sizing: border-box;
		padding: 10px;
		box-shadow: 0px 0px 2px darkgrey;
		margin-bottom: 10px;
		font-size: 14px;
	}

	.card_body {
		position: relative;
		width: 100%;

	}

	.card_right {
		position: relative;
		flex-direction: row;
		width: 50px;
		height: 100%;
		align-items: center;
		justify-content: center;
	}

	.card_item {
		flex: 1;
		position: relative;

		/* 		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis; */
		margin-bottom: 10px;
	}

	.card_button {
		flex-direction: row;
		justify-content: flex-end;
		margin: 10px 0;
	}

	.operatebutton_container {
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	export default {
		props: {

		},
		data() {
			return {
				searchShow: false,
				searchform:{
					billcode:null,
					supplier:null,
				},
				warehousetype: 1,
				formShow: false,
				form: {
					mark: ''
				},
				sourcedata: [],
				timemapdata: [],
				data: {
					'物流': [],
					'自提': [],
					'已提': [],
				},
				detial: [],
				filterDate: [],
				activeKey: 1,
				detailShow: false,
				calendarShow: false,
				currentdate: 0,
				minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.currentdate = new Date().setHours(0, 0, 0, 0) / 1000
			this.list()
		},
		computed: {

		},

		methods: {
			getshowdata() {
				let showdata = this.sourcedata.filter((item) => {
					if (this.warehousetype == 1) {
						return item.takedepartmentid == item.relationdepartmentid
					} else {
						return item.takedepartmentid != item.relationdepartmentid
					}

				})
				return showdata
			},
			reflash() {
				for(let i in this.searchform){
					this.searchform[i] = null
				}
				this.filterDate = []
				this.$refs.calendar.reset()
				this.list()
			},
			list(param = {}) {
				let handle = this.$loading()
				let preparam = {
					currentPage: -1
				}
				this.$api.takegoods.list({
					...preparam,
					...param,
					...this.searchform
				}).then((res) => {
					this.sourcedata = JSON.parse(JSON.stringify(res.list))
					this.sourcedata.forEach((item) => {
						item.pregettime = new Date(item.pregettime * 1000).setHours(0, 0, 0, 0)
						item.checked = false
						if (item.marktime) {
							item.checked = item.marktime >= this.currentdate ? true : false
						}

					})
					let timemapdata = this.$Lodash.groupBy(this.sourcedata, 'pregettime')
					for (let i in timemapdata) {
						let gourpsupplier = this.$Lodash.groupBy(timemapdata[i], 'supplierName')
						timemapdata[i] = this.$Lodash.keys(gourpsupplier)
					}
					this.timemapdata = timemapdata

					this.initData(this.getshowdata())
					this.$loadingclose(handle)
				}, () => {
					this.$loadingclose(handle)
				})
			},
			initData(sourcedata = null) {
				let data = []
				let takedata = []
				let outofstockdata = []
				let useabledata = this.getshowdata()
				if (sourcedata) {
					useabledata = sourcedata
				}
				let _sourcedata = useabledata.filter((item) => {
					return item.marktake != 1 && item.isoutofstock != 1
				})
				let take_sourcedata = useabledata.filter((item) => {
					return item.marktake != 0
				})
				let outofstock_sourcedata = useabledata.filter((item) => {
					return item.isoutofstock != 0
				})
				let groupdata = this.$Lodash.groupBy(_sourcedata, 'supplierName')
				for (let i in groupdata) {
					let obj = {}
					obj.billID = groupdata[i][0].billID
					obj.pregettime = groupdata[i][0].pregettime
					obj.supplierName = groupdata[i][0].supplierName
					obj.urgent = groupdata[i][0].urgent
					obj.storageName = groupdata[i][0].storageName
					obj.parceltype = groupdata[i][0].parceltype
					obj.remark = groupdata[i][0].remark
					obj.checked = groupdata[i][0].checked
					obj.detail = groupdata[i]
					data.push(obj)
				}
				groupdata = this.$Lodash.groupBy(take_sourcedata, 'supplierName')
				for (let i in groupdata) {
					let obj = {}
					obj.billID = groupdata[i][0].billID
					obj.pregettime = groupdata[i][0].pregettime
					obj.supplierName = groupdata[i][0].supplierName
					obj.urgent = groupdata[i][0].urgent
					obj.storageName = groupdata[i][0].storageName
					obj.parceltype = groupdata[i][0].parceltype
					obj.remark = groupdata[i][0].remark
					obj.checked = groupdata[i][0].checked
					obj.detail = groupdata[i]
					takedata.push(obj)
				}

				groupdata = this.$Lodash.groupBy(outofstock_sourcedata, 'supplierName')
				for (let i in groupdata) {
					let obj = {}
					obj.billID = groupdata[i][0].billID
					obj.pregettime = groupdata[i][0].pregettime
					obj.supplierName = groupdata[i][0].supplierName
					obj.urgent = groupdata[i][0].urgent
					obj.storageName = groupdata[i][0].storageName
					obj.parceltype = groupdata[i][0].parceltype
					obj.remark = groupdata[i][0].remark
					obj.checked = groupdata[i][0].checked
					obj.detail = groupdata[i]
					outofstockdata.push(obj)
				}


				let parcel = this.$Lodash.groupBy(data, 'parceltype')
				this.data['物流'] = parcel[7974] ? this.$Lodash.orderBy(parcel[7974], 'urgent', 'desc') : []
				this.data['自提'] = parcel[8114] ? this.$Lodash.orderBy(parcel[8114], 'urgent', 'desc') : []
				this.data['已提'] = takedata
				this.data['缺货'] = outofstockdata
				console.log(data)

			},

			detail(row) {
				let detial = []
				let groupdata = this.$Lodash.groupBy(row.detail, 'billCode')
				for (let i in groupdata) {
					let obj = {}
					obj.billCode = groupdata[i][0].billCode
					obj.remark = groupdata[i][0].remark
					obj.reportTime = groupdata[i][0].reportTime
					obj.pregettime = groupdata[i][0].pregettime
					obj.detail = this.$Lodash.groupBy(groupdata[i], 'goodsName')
					detial.push(obj)
				}
				this.detial = detial
				console.log(detial)
				this.detailShow = true
			},
			// searchreset(){
			// 	for(let i in this.searchform){
			// 		this.searchform[i] = null
			// 	}
			// 	this.searchShow = false
			// 	this.list()
			// },
			onsearchSubmit(){
				this.searchShow = false
				this.list()
			},
			search(){
				this.searchShow = true
			},
			calendar() {
				this.calendarShow = true
			},
			formatter(day) {
				let time = day.date.getTime()
				day.bottomInfo = this.timemapdata[time] ? this.timemapdata[time].length + '个' : ''
				return day
			},
			sidebarChange(e) {
				if (e == 0) {
					this.filterDate = []
					this.$refs.calendar.reset()
				}
				this.getDataByDate()

			},
			onConfirm(e) {
				this.filterDate = []
				let time = e.sort((a, b) => {
					return a - b
				})
				time.forEach((item) => {
					let time = new Date(item.getTime()).setHours(0, 0, 0, 0)
					let title = window.systemMethods.timestampToDate(time, true)
					title = title.split('-')
					title = title[1] + '-' + title[2]
					this.filterDate.push({
						title: title,
						time: time,
						badge: this.timemapdata[time] ? this.timemapdata[time].length : ''
					})
				})
				this.activeKey = 1
				this.getDataByDate()
				this.calendarShow = false
				//console.log(e)
			},
			getDataByDate() {
				if (this.filterDate.length != 0) {
					let data = this.getshowdata().filter((item) => {
						return item.pregettime == this.filterDate[this.activeKey - 1].time
					})
					this.initData(data)
				} else {
					this.initData(this.getshowdata())
				}
			},
			checkChange(item) {
				this.getshowdata().forEach((sourceItem) => {
					if (sourceItem.supplierName == item.supplierName) {
						sourceItem.checked = item.checked
					}
				})
				this.$api.takegoods.updatefromlist(0, {
					type: 'mark',
					billIDs: [item.billID],
					marktime: item.checked ? 1 : 0
				})
			},
			warehousetypeChange(e) {
				this.warehousetype = e
				this.initData(this.getshowdata())
				this.getDataByDate()
			},
			formSubmit() {
				this.updatefromlist('outofstock').then(() => {
					this.currentdetail.outofstockmark = this.form.mark
					this.currentdetail.isoutofstock = this.currentdetail.prechecked
				})
			},
			formCancel() {

			},
			marktakeChange(item) {
				this.currentdetail = item
				this.updatefromlist('marktake').then(() => {
					this.getshowdata().forEach((data) => {
						if (data.detailID == item.detailID) {
							data.marktake = this.currentdetail.marktake ? 1 : 0
						}
					})
					this.initData(this.getshowdata())
				})
			},
			outofstockChange(checked, item) {
				item.prechecked = checked
				this.currentdetail = item
				if (checked) {
					this.form = {
						mark: ''
					}
					this.formShow = true
				} else {
					this.updatefromlist('outofstock').then(() => {
						item.outofstockmark = ''
						item.isoutofstock = checked
					})

				}
			},
			updatefromlist(type) {
				return new Promise((reslove) => {
					this.$api.takegoods.updatefromlist(0, {
						type: type,
						billIDs: [this.currentdetail.billID],
						detailID: this.currentdetail.detailID,
						billCode: this.currentdetail.billCode,
						goodsName: this.currentdetail.goodsName,
						skuName: this.currentdetail.skuName,
						storageID: this.currentdetail.storageID,
						supplierName: this.currentdetail.supplierName,
						storageName: this.currentdetail.storageName,
						isoutofstock: this.currentdetail.prechecked ? 1 : 0,
						marktake: this.currentdetail.marktake ? 1 : 0,
						outofstockmark: this.form.mark,
					}).then(() => {
						reslove()
					})
				})
			}

		},
		components: {

		}
	}
</script>